import Phaser from 'phaser';

const COLOR_RED = 0xef4444;
const COLOR_WHITE = 0xffffff;
const COLOR_BLUE = 0x2563eb;
const COLOR_STROKE = 0x0a0f1f;

export function drawShield(g: Phaser.GameObjects.Graphics, size: number) {
  g.clear();
  const pad = Math.max(4, Math.floor(size * 0.08));
  const r = (size - pad * 2) / 2;
  const stroke = Math.max(3, Math.floor(size * 0.06));

  g.lineStyle(stroke, COLOR_STROKE, 1);

  g.fillStyle(COLOR_RED, 1);
  g.fillCircle(0, 0, r);
  g.strokeCircle(0, 0, r);

  g.fillStyle(COLOR_WHITE, 1);
  g.fillCircle(0, 0, r * 0.78);

  g.fillStyle(COLOR_RED, 1);
  g.fillCircle(0, 0, r * 0.56);

  g.fillStyle(COLOR_BLUE, 1);
  g.fillCircle(0, 0, r * 0.34);

  drawStar(g, 0, 0, r * 0.3, r * 0.12, 5, COLOR_WHITE);
}

function drawStar(
  g: Phaser.GameObjects.Graphics,
  cx: number,
  cy: number,
  outerR: number,
  innerR: number,
  points: number,
  fill: number,
) {
  const pts: { x: number; y: number }[] = [];
  const step = Math.PI / points;
  for (let i = 0; i < points * 2; i++) {
    const r = i % 2 === 0 ? outerR : innerR;
    const a = -Math.PI / 2 + i * step;
    pts.push({ x: cx + r * Math.cos(a), y: cy + r * Math.sin(a) });
  }
  g.fillStyle(fill, 1);
  g.beginPath();
  g.moveTo(pts[0].x, pts[0].y);
  for (let i = 1; i < pts.length; i++) g.lineTo(pts[i].x, pts[i].y);
  g.closePath();
  g.fillPath();
}
